import { useMutation, useQueryClient } from '@tanstack/react-query';
import type {
	MaintenanceMixture,
	MaintenanceMixtureSettings,
} from '../../../recommendations/types';
import { useForBindingId } from '../../../forBinding';
import api from '../../http';
import { toApiError } from '../utils';

export interface FractionateFertilizationPayload extends MaintenanceMixtureSettings {
	planId: string;
}

export function usePostFractionateFertilization() {
	const queryClient = useQueryClient();
	const forBinding = useForBindingId();

	return useMutation<{ mixtures: MaintenanceMixture[] }, Error, FractionateFertilizationPayload>({
		mutationFn: async (payload) => {
			try {
				const { data } = await api.post<{ mixtures: MaintenanceMixture[] }>(
					'/advices/fertilization-plan/fractionate-fertilization',
					payload,
					{ params: { forBinding } }
				);
				return data;
			} catch (error) {
				throw toApiError(error, 'Erro ao elaborar as misturas');
			}
		},
		onSettled: (_data, _error, variables) =>
			queryClient.invalidateQueries({ queryKey: ['maintenance', variables.planId] }),
	});
}
